import {AvatarInput} from '@/components/refinedev/AvatarInput';
import CheckboxInput from '@/components/refinedev/CheckboxInput';
import SelectInput from '@/components/refinedev/SelectInput';
import TextInput from '@/components/refinedev/TextInput';
import Section from '@/components/surface/Section';
import {useDepartmentList, useJobList} from 'pages/_utils';
import {RoleInput} from '../roles/components';
import {useResourceParams} from '@refinedev/core';
import {ChangeAccountPasswordButton} from '@/pages/_shared/change-password-button';
import {useWatch} from 'react-hook-form';
import TextareaInput from '@/components/refinedev/TextareaInput';

export const UserForm = () => {
  const {action, id} = useResourceParams();
  const isEdit = action === 'edit';
  const getDepartmentListResult = useDepartmentList();
  const getJobListResult = useJobList();

  return (
    <div className="w-full flex flex-row flex-wrap gap-y-4">
      <div className="lg:basis-1/3 md:basis-1/2 w-full px-2">
        <Section title="Nhân viên" subtitle="Nhập thông tin của nhân viên">
          <AvatarInput source="staff.avatar" label="Ảnh đại diện" />
          <TextInput source="staff.staff_no" label="Số hiệu nhân viên" />
          <TextInput source="staff.name" label="Họ và tên" />
          <TextInput source="staff.mobile" label="Số điện thoại" />
          <TextInput source="staff.email" label="Email" />
          <TextInput source="staff.current_address" label="Địa chỉ" />
          <SelectInput
            source="staff.department_id"
            label="Phòng ban"
            optionText="name"
            choices={getDepartmentListResult.data?.data || []}
          />
          <SelectInput
            source="staff.job_id"
            label="Công việc"
            optionText="title"
            choices={getJobListResult.data?.data || []}
          />
          <TextareaInput source="staff.notes" label="Ghi chú" />
        </Section>
      </div>
      <div className="lg:basis-1/3 md:basis-1/2 w-full px-2">
        <Section
          // className="lg:basis-1/3 md:basis-1/2 w-full px-2"
          title="Tài khoản"
          subtitle="Thông tin tài khoản">
          <TextInput
            source="username"
            label="Tên đăng nhập"
            autoComplete="new-password"
            disabled={isEdit}
          />
          <TextInput
            source="password"
            label="Mật khẩu"
            type="password"
            autoComplete="new-password"
          />
          <TextInput
            source="password_confirmation"
            label="Xác nhận mật khẩu"
            type="password"
            autoComplete="new-password"
          />
          <RoleInput source="roles" label="Phân quyền" placeHolder="Chọn phân quyền" />
        </Section>
      </div>
    </div>
  );
};

export const transformBeforeSave = inputData => {
  const data = {
    ...inputData,
    name: inputData.staff?.name,
    roles: inputData.roles?.map(r => r.id),
    staff: inputData.staff
      ? {
          ...inputData.staff,
          department: undefined,
          job: undefined,
        }
      : undefined,
  };
  return data;
};
